module.exports = __webpack_public_path__ + "images/emoji/ticket.2716481da3574aca1f6d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ticket.png
// module id = G+vV
// module chunks = 13